import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  theme: {
    primary: "#546e7a",
    secondary: "#000000",
    accent: "#3F51B5",
    headingColor: "#455a64",
    gray: "#cccccc"
  },
  iconfont: "md"
});
